/**
 * Single source of truth for CloudFront base URLs per environment.
 * Used when building public asset URLs (images, videos, etc.) instead of direct S3 URLs.
 */
export const CLOUDFRONT_BASE_URLS = {
  production: 'https://dincw249g51dg.cloudfront.net/',
  staging: 'https://d305azfm3bd2ih.cloudfront.net/',
  localhost: 'https://d3hkeo8cdwh3e9.cloudfront.net/',
  /** Alias for localhost; same distribution used for local dev */
  development: 'https://d3hkeo8cdwh3e9.cloudfront.net/'
};

export const CLOUDFRONT_PRIVATE_BASE_URLS = {
  production: 'https://d3n7r1q4en810f.cloudfront.net/',
  staging: 'https://d2hd4konzqnrkp.cloudfront.net/',
  localhost: 'https://d2dvpewuv7carr.cloudfront.net/',
  /** Alias for localhost; same distribution used for local dev */
  development: 'https://d2dvpewuv7carr.cloudfront.net/'
};

export const DEFAULT_CLOUDFRONT_BUCKET_URL = 'https://dcahtweeeoeqs.cloudfront.net/';
/**
 * Gets the CloudFront base URL for the given environment.
 * @param env - The environment ('development', 'localhost', 'staging', or 'production')
 * @returns The CloudFront base URL (with trailing slash)
 */
export function getCloudFrontBaseUrl(env:any) {
  const normalizedEnv =
    env === 'development' || env === 'localhost'
      ? 'localhost'
      : env === 'staging'
        ? 'staging'
        : 'production';
  return CLOUDFRONT_BASE_URLS[normalizedEnv] ?? CLOUDFRONT_BASE_URLS.staging;
}
